export enum PRODUCT {
  TYPE = 'review'
}

export enum FLOW {
  CITIES = 'cities',
  THANKS = 'cities_thanks',
  CITIES_E = 'cities-e'
}

export enum EVENT_ACTION {
  CLICK = 'click',
  SELECTION = 'selection',
  ORIGIN = 'origin'
}

export enum EVENT_TYPE {
  START = 'start',
  CONTINUE = 'continue',
  SKIP = 'skip'
}
